import { render, staticRenderFns } from "./user-avatar.vue?vue&type=template&id=6c09d56a"
import script from "./user-avatar.vue?vue&type=script&lang=js"
export * from "./user-avatar.vue?vue&type=script&lang=js"
import style0 from "./user-avatar.vue?vue&type=style&index=0&id=6c09d56a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports